import script from "./UnAuthorizedPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UnAuthorizedPage.vue?vue&type=script&setup=true&lang=js"

import "./UnAuthorizedPage.vue?vue&type=style&index=0&id=d8e2681e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8e2681e"]])

export default __exports__